import * as _ from "lodash";
import {IRootModel} from "@/shared/models/abstract/IRootModel";

/**
 * Simple limited capacity stack.
 */
export default class RecentStack {
    private readonly _capacity: number;
    private _list: IRootModel[];


    constructor(capacity: number = 10) {
        this._capacity = capacity;
        this._list = [];
    }

    public get isEmpty() {
        return this.count === 0;
    }

    public get count() {
        return this._list.length;
    }

    public push(...items: IRootModel[]): void {
        items.forEach(item => {
            // no duplicates here
            if (this.isRecent(item.id)) {
                return;
            }
            this._list.unshift(item);
            if (this.count > this._capacity) {
                this._list.pop();
            }
        });
    }

    private isRecent(id: string) {
        const found = this._list.find(r => r.id === id);
        return !_.isNil(found);
    }


    public pop(): IRootModel {
        return this._list.shift();
    }

    public peek(): IRootModel {
        if (this.count > 0) {
            return this._list[0];
        }
        return null;
    }

    public clear() {
        this._list = [];
    }

    public remove(predicate: (item: IRootModel) => boolean) {
        _.remove(this._list, predicate);
    }

    public getAll() {
        return this._list;
    }

}
